import * as type from "../types";

const initialState = {
  logins: [],
  details: {
    companies: [],
    id: null,
    firstName: null,
    lastName: null,
    mobile: null,
    role: null,
    thumbnail: null,
    notifications: [],
  },
  fetchLogins: {
    status: null,
    loading: true,
    error: null,
  },
  fetchUserDetails: {
    status: null,
    loading: false,
    error: null,
  },
  fetchName: {
    status: null,
    loading: false,
    error: null,
  },
  fetchThumbnail: {
    status: null,
    loading: false,
    error: null,
  },
  updateInfo: {
    status: null,
    loading: false,
    error: null,
  },
  updateGeneral: {
    status: null,
    loading: false,
    error: null,
  },
  updatePassword: {
    status: null,
    loading: false,
    error: null,
  },
  updateImage: {
    status: null,
    loading: false,
    error: null,
  },
  deleteImage: {
    status: null,
    loading: false,
    error: null,
  },
  fetchCompanies: {
    status: null,
    loading: false,
    error: null,
  },
  acceptInvitation: {
    id: null,
    status: null,
    loading: false,
    error: null,
  },
  rejectInvitation: {
    id: null,
    status: null,
    loading: false,
    error: null,
  },
  updateUnseenNotifications: {
    status: null,
    loading: false,
    error: null,
  },
  fetchNotificationsList: {
    status: null,
    loading: false,
    error: null,
  },
};

export const user = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_USER_DETAILS:
      return {
        ...state,
        fetchUserDetails: {
          ...state.fetchUserDetails,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_USER_DETAILS:
      return {
        ...state,
        details: payload.user,
        fetchUserDetails: {
          ...state.fetchUserDetails,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_USER_DETAILS:
      return {
        ...state,
        details: {
          companies: [],
          id: null,
          firstName: null,
          lastName: null,
          mobile: null,
          role: null,
          thumbnail: null,
          notifications: [],
        },
        fetchUserDetails: {
          ...state.fetchUserDetails,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.REMOVE_USER_DETAILS:
      return {
        ...state,
        logins: [],
        details: {
          companies: [],
          id: null,
          firstName: null,
          lastName: null,
          mobile: null,
          role: null,
          thumbnail: null,
          notifications: [],
        },
        fetchLogins: {
          status: null,
          loading: true,
          error: null,
        },
        fetchUserDetails: {
          status: null,
          loading: false,
          error: null,
        },
        fetchName: {
          status: null,
          loading: false,
          error: null,
        },
        fetchThumbnail: {
          status: null,
          loading: false,
          error: null,
        },
        updateInfo: {
          status: null,
          loading: false,
          error: null,
        },
        updateGeneral: {
          status: null,
          loading: false,
          error: null,
        },
        updatePassword: {
          status: null,
          loading: false,
          error: null,
        },
        updateImage: {
          status: null,
          loading: false,
          error: null,
        },
        deleteImage: {
          status: null,
          loading: false,
          error: null,
        },
        fetchCompanies: {
          status: null,
          loading: false,
          error: null,
        },
        fetchMoreNotifications: {
          status: null,
          loading: false,
          error: null,
        },
        acceptInvitation: {
          details: null,
          status: null,
          loading: false,
          error: null,
        },
        declineInvitation: {
          status: null,
          loading: false,
          error: null,
        },
        fetchUpdatedNotifications: {
          status: null,
          loading: false,
          error: null,
        },
        updateSeenNotifications: {
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_USER_COMPANIES:
      return {
        ...state,
        fetchCompanies: {
          ...state.fetchCompanies,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_USER_COMPANIES:
      return {
        ...state,
        fetchCompanies: {
          ...state.fetchCompanies,
          status: null,
          loading: false,
          error: null,
        },
        details: {
          ...state.details,
          companies: payload.companies,
        },
      };
    case type.REVOKE_USER_COMPANIES:
      return {
        ...state,
        fetchCompanies: {
          ...state.fetchCompanies,
          status: null,
          loading: false,
          error: payload.message,
        },
        details: {
          ...state.details,
          companies: [],
        },
      };
    case type.RESET_USER_COMPANIES:
      return {
        ...state,
        fetchCompanies: {
          ...state.fetchCompanies,
          status: null,
          loading: false,
          error: null,
        },
        details: {
          ...state.details,
          companies: [],
        },
      };
    case type.REQUEST_UPDATE_USER_INFO:
      return {
        ...state,
        updateInfo: {
          ...state.updateInfo,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_USER_INFO:
      return {
        ...state,
        updateInfo: {
          ...state.updateInfo,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_USER_INFO:
      return {
        ...state,
        updateInfo: {
          ...state.updateInfo,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_USER_INFO:
      return {
        ...state,
        updateInfo: {
          ...state.updateInfo,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_USER_FULL_NAME:
      return {
        ...state,
        fetchName: {
          ...state.fetchName,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_USER_INFO:
      return {
        ...state,
        fetchName: {
          ...state.fetchName,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_USER_FULL_NAME:
      return {
        ...state,
        fetchName: {
          ...state.fetchName,
          status: null,
          loading: false,
          error: null,
        },
        details: {
          ...state.details,
          firstName: payload.data.firstName,
          lastName: payload.data.lastName,
        },
      };
    case type.RESET_USER_FULL_NAME:
      return {
        ...state,
        fetchName: {
          ...state.fetchName,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_UPDATE_USER_GENERAL:
      return {
        ...state,
        updateGeneral: {
          ...state.updateGeneral,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_USER_GENERAL:
      return {
        ...state,
        updateGeneral: {
          ...state.updateGeneral,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_USER_GENERAL:
      return {
        ...state,
        updateGeneral: {
          ...state.updateGeneral,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_USER_GENERAL:
      return {
        ...state,
        updateGeneral: {
          ...state.updateGeneral,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_UPDATE_USER_PASSWORD:
      return {
        ...state,
        updatePassword: {
          ...state.updatePassword,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_USER_PASSWORD:
      return {
        ...state,
        updatePassword: {
          ...state.updatePassword,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_USER_PASSWORD:
      return {
        ...state,
        updatePassword: {
          ...state.updatePassword,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_USER_PASSWORD:
      return {
        ...state,
        updatePassword: {
          ...state.updatePassword,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_USER_LOGINS:
      return {
        ...state,
        fetchLogins: {
          ...state.fetchLogins,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_USER_LOGINS:
      return {
        ...state,
        logins: payload.logins,
        fetchLogins: {
          ...state.fetchLogins,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_USER_LOGINS:
      return {
        ...state,
        fetchLogins: {
          ...state.fetchLogins,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.REMOVE_USER_LOGINS:
      return {
        ...state,
        logins: null,
      };
    case type.REQUEST_UPDATE_USER_IMAGE:
      return {
        ...state,
        updateImage: {
          ...state.updateImage,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_USER_IMAGE:
      return {
        ...state,
        updateImage: {
          ...state.updateImage,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_USER_IMAGE:
      return {
        ...state,
        updateImage: {
          ...state.updateImage,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_USER_IMAGE:
      return {
        ...state,
        updateImage: {
          ...state.updateImage,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_DELETE_USER_IMAGE:
      return {
        ...state,
        deleteImage: {
          ...state.deleteImage,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELETE_USER_IMAGE:
      return {
        ...state,
        deleteImage: {
          ...state.deleteImage,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_DELETE_USER_IMAGE:
      return {
        ...state,
        deleteImage: {
          ...state.deleteImage,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_DELETE_USER_IMAGE:
      return {
        ...state,
        deleteImage: {
          ...state.deleteImage,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_USER_IMAGE:
      return {
        ...state,
        fetchThumbnail: {
          ...state.fetchThumbnail,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_USER_IMAGE:
      return {
        ...state,
        fetchThumbnail: {
          ...state.fetchThumbnail,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_USER_IMAGE:
      return {
        ...state,
        fetchThumbnail: {
          ...state.fetchThumbnail,
          status: "success",
          loading: false,
          error: null,
        },
        details: {
          ...state.details,
          thumbnail: payload.image,
        },
      };
    case type.RESET_USER_IMAGE:
      return {
        ...state,
        fetchThumbnail: {
          ...state.fetchThumbnail,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_ACCEPT_INVITATION:
      return {
        ...state,
        acceptInvitation: {
          ...state.acceptInvitation,
          id: payload.payload.id,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_ACCEPT_INVITATION:
      return {
        ...state,
        acceptInvitation: {
          ...state.acceptInvitation,
          id: null,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_ACCEPT_INVITATION:
      return {
        ...state,
        acceptInvitation: {
          ...state.acceptInvitation,
          id: null,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_ACCEPT_INVITATION:
      return {
        ...state,
        acceptInvitation: {
          id: null,
          ...state.acceptInvitation,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_REJECT_INVITATION:
      return {
        ...state,
        rejectInvitation: {
          ...state.rejectInvitation,
          id: payload.payload.id,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_REJECT_INVITATION:
      return {
        ...state,
        rejectInvitation: {
          ...state.rejectInvitation,
          id: null,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_REJECT_INVITATION:
      return {
        ...state,
        rejectInvitation: {
          ...state.rejectInvitation,
          id: null,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_REJECT_INVITATION:
      return {
        ...state,
        rejectInvitation: {
          ...state.rejectInvitation,
          id: null,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_UPDATE_UNSEEN_NOTIFICATIONS:
      return {
        ...state,
        updateUnseenNotifications: {
          ...state.updateUnseenNotifications,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_UPDATE_UNSEEN_NOTIFICATIONS:
      return {
        ...state,
        updateUnseenNotifications: {
          ...state.updateUnseenNotifications,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_UNSEEN_NOTIFICATIONS:
      return {
        ...state,
        updateUnseenNotifications: {
          ...state.updateUnseenNotifications,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_UPDATE_UNSEEN_NOTIFICATIONS:
      return {
        ...state,
        updateUnseenNotifications: {
          ...state.updateUnseenNotifications,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_FETCH_NOTIFICATIONS:
      return {
        ...state,
        fetchNotificationsList: {
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_FETCH_NOTIFICATIONS:
      return {
        ...state,
        details: {
          ...state.details,
          notifications: payload.notifications,
        },
        fetchNotificationsList: {
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_FETCH_NOTIFICATIONS:
      return {
        ...state,
        fetchNotificationsList: {
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_FETCH_NOTIFICATIONS:
      return {
        ...state,
        fetchNotificationsList: {
          status: null,
          loading: false,
          error: null,
        },
      };
    default:
      return state;
  }
};
